import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Field, reduxForm, getFormValues } from "redux-form";
import { connect } from "react-redux";
import Modal from "../../../Components/Modal";
import { required, numericality } from "redux-form-validators";
import { renderField } from "../../../Components/Forms/renders";
import { updateklant } from "../Reducers/actions";

const ContactWijzigen = ({ handleSubmit, boeking, formValues, updateklant }) => {
  const [visible, setVisible] = useState(false);

  const onSubmit = async (values) => {
    try {
      await updateklant(boeking._id, values);
      setVisible(false);
    } catch (error) {
      console.error("Fout bij het opslaan van contactgegevens:", error);
    }
  };

  return (
    <>
      <button className="btn btn-sm btn-info mx-2" onClick={() => setVisible(true)}>
        Contact bewerken
      </button>
      {createPortal(
        <Modal visible={visible} onClose={() => setVisible(false)} width={600}>
          <div className="card">
            <div className="card-header">
              <h4 className="mb-0">Contactgegevens wijzigen</h4>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="card-body">
                <Field name="klanten.voornaam" type="input" validate={required({ msg: "Voornaam is verplicht" })} component={renderField} label="Voornaam" />
                <Field name="klanten.tussenvoegsel" type="input" component={renderField} label="Tussenvoegsel" />
                <Field name="klanten.achternaam" type="input" validate={required({ msg: "Achternaam is verplicht" })} component={renderField} label="Achternaam" />
                <Field name="klanten.email" type="input" validate={required({ msg: "Email is verplicht" })} component={renderField} label="Email" />
                <Field name="klanten.telefoonnummer" type="input" validate={required({ msg: "Telefoonnummer is verplicht" })} component={renderField} label="Telefoonnummer" />
              </div>
              <div className="card-footer d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={() => setVisible(false)}>
                  Annuleren
                </button>
                <button type="submit" className="btn btn-primary">
                  Opslaan
                </button>
              </div>
            </form>
          </div>
        </Modal>,
        document.body
      )}
    </>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "changecontactarrangemebnt", // a unique identifier for this form
})(ContactWijzigen);

const mapStateToProps = (state) => ({
  initialValues: state.boekingen.item,
  boeking: state.boekingen.item,
});

const mapDispatchToProps = {
  updateklant,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReduxFormSensorEdit);
